import "./App.css";
import FluidGradientBackground from "./components/FluidGradientBackground";
import Card from "./components/Card";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InfoSection from "./components/InfoSection";
import { useState, useRef, useEffect } from "react";
import HeroArea from "./components/HeroArea";
import restaurantImage1 from "./assets/image1.jpeg";
import restaurantImage2 from "./assets/image2.jpeg";
import restaurantImage3 from "./assets/image4.jpeg";

const restaurants = [
  {
    name: "Ale, ale, Aleje!",
    shortName: "Aleje",
    image: restaurantImage1,
    address: "Aleje Jerozolimskie 228, Warszawa",
    addressLink:
      "https://www.google.com/maps/place/Restauracja+McDonald's/@52.1884009,20.909504,18.91z/data=!3m1!5s0x47193495bdfc0953:0x4c97370c83335fbb!4m6!3m5!1s0x471935cb349175ff:0xfba3f4b4f1d38c9e!8m2!3d52.1878292!4d20.9103647!16s%2Fg%2F11jrchq56v?coh=164777&entry=tt&shorturl=1",
    phone: "+48 600 354 628",
    phoneLink: "tel:+48600354628",
    hoursDetail: "7:00 - 00:00",
    details: [
      "🪑 - Ilość miejsc siedzących: Sala: 78 | Ogródek: 44.",
      "🅿️ – Miejsca parkingowe: 23 (W tym 1 dla niepełnosprawnych).",
      "🚲 – Stojak na rowery.",
      "🚻 – Toaleta dla niepełnosprawnych.",
      "🚘 – Możliwość podjechania samochodem i zamówienia, McDrive.",
      "🍽️ – Możliwość zamówienia do stolika lub miejsca parkingowego (2 specjalnie oznaczone miejsca).",
      "📲 – Możliwość zamówienia przez Uber, Pyszne, Glovo i Wolt.",
      "📱- Możliwość złożenia zamówienia przez aplikację w telefonie lub kioski.",
      "🥚 & 🍔 – Oferta śniadaniowa i klasyczna.",
    ],
  },
  {
    name: "Femina",
    shortName: "Femina",
    image: restaurantImage2,
    address: "Aleja Solidarności 117, Warszawa",
    addressLink: "https://www.google.com/maps/place/Restauracja+McDonald's/@52.2412618,20.9942271,17.96z/data=!3m1!5s0x471ecb5df54d1587:0x397aa17afd3368b!4m6!3m5!1s0x471ecc7d99088f93:0xb7b257cc41d44a81!8m2!3d52.241853!4d20.9943058!16s%2Fg%2F1tfslr4k?coh=164777&entry=tt&shorturl=1",
    phone: "+48 664 353 450",
    phoneLink: "tel:+48664353450",
    hoursDetail: "7:00 - 00:00",
    details: [
      "🪑 – Ilość miejsc siedzących: Sala: 32; Ogródek: 14",
      "🚻 – Toaleta dla niepełnosprawnych.",
      "🚲 – Stojak na rowery w pobliżu restauracji.",
      "📲 – Możliwość zamówienia przez Uber, Pyszne, Glovo i Wolt.",
      "📱 – Możliwość złożenia zamówienia przez aplikację w telefonie lub kioski.",
      "🪟 – Możliwość zamówienia przez okienko.",
      "🥚 & 🍔 – Oferta śniadaniowa i klasyczna.",
    ],
  },
  {
    name: "Reduta",
    shortName: "Reduta",
    image: restaurantImage3,
    address: "Aleje Jerozolimskie 148, Warszawa",
    addressLink: "https://www.google.com/maps/place/Restauracja+McDonald's/@52.2129707,20.9489657,17z/data=!3m1!5s0x471ecb572eb86c59:0x256d9fbe251b36bc!4m6!3m5!1s0x471ecb56d8786179:0x4a4ab507db7975da!8m2!3d52.2124482!4d20.9512644!16s%2Fg%2F1tdzk9q6?coh=164777&entry=tt&shorturl=1",
    phone: "+48 694 493 513",
    phoneLink: "tel:+48694493513",
    hoursDetail: "10:00 - 21:00",
    details: [
      "🪑 – Ilość miejsc siedzących: 82.",
      "📲 – Możliwość zamówienia przez Uber, Glovo i Wolt.",
      "📱 – Możliwość złożenia zamówienia przez aplikację w telefonie lub kioski.",
      "🍔 – Oferta klasyczna.",
    ],
  },
];

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef(null);
  const restaurantCardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCurrentIndex(Number(entry.target.dataset.index));
          }
        });
      },
      { threshold: 0.6 }
    );

    restaurantCardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const scrollToRestaurant = (index) => {
    const container = scrollContainerRef.current;
    const card = restaurantCardsRef.current[index];
    if (!container || !card) return;
    container.scrollTo({
      left: card.offsetLeft - container.offsetLeft,
      behavior: "smooth",
    });
  };

  const handlePrevRestaurant = () => {
    if (currentIndex > 0) scrollToRestaurant(currentIndex - 1);
  };

  const handleNextRestaurant = () => {
    if (currentIndex < restaurants.length - 1)
      scrollToRestaurant(currentIndex + 1);
  };

  return (
    <div className="App">
      <FluidGradientBackground />
      <Navbar openModal={toggleModal} />
      <main className="content">
        {/* <GeneralInfoSection /> */}
        <HeroArea />
        <section>
          <h1>Nasze restauracje.</h1>
          <div className="restaurants-scroll-container" ref={scrollContainerRef}>
            {restaurants.map((restaurant, index) => (
              <div
                key={index}
                className="restaurant-card"
                data-index={index}
                ref={(el) => {
                  restaurantCardsRef.current[index] = el;
                }}
              >
                <InfoSection restaurant={restaurant} />
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer
        openModal={toggleModal}
        currentName={restaurants[currentIndex].shortName}
        currentIndex={currentIndex}
        total={restaurants.length}
        onPrev={handlePrevRestaurant}
        onNext={handleNextRestaurant}
      />
      <Card isOpen={isModalOpen} toggleModal={toggleModal} />
    </div>
  );
}

export default App;
